import { NotAuthorizedIntent } from "@/@types/NotAuthorizedIntent";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { NotAuthorizedIntentsContent } from "./NotAuthorizedIntentsList";

type RefusalHistoryModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  intents: NotAuthorizedIntent[];
};

export function RefusalHistoryModal({
  open,
  onOpenChange,
  intents,
}: RefusalHistoryModalProps) {
  const { t } = useTranslation(["sales"]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-hidden flex flex-col p-0">
        <DialogHeader className="p-6 pb-4 border-b border-colorBorder shrink-0">
          <DialogTitle className="text-xl font-semibold">
            {t("refusal_history")}
          </DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto p-6 pt-4">
          <NotAuthorizedIntentsContent intents={intents} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
